import React, { useEffect, useRef } from "react";
import { Form, Input, Button } from "antd";
import { SendOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { CALL_API } from "../../Common/api";
import { useSelector } from "react-redux";

const ChatWrap = styled.div`
  .chat-container {
    background-color: #edf7ed; /* Light green background */
    padding: 16px;
    border-radius: 12px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

    margin: auto;
    display: flex;
    flex-direction: column;
    height: 500px;
  }

  .chat-discussion {
    flex-grow: 1;
    overflow-y: auto;
    padding: 10px;
    display: flex;
    flex-direction: column;
  }

  /* Chat Message Styling */
  .chat-message {
    display: flex;
    margin-bottom: 10px;
    max-width: 80%;
  }

  .chat-message.right {
    justify-content: flex-end;
    align-self: flex-end;
  }

  .chat-message.left {
    justify-content: flex-start;
    align-self: flex-start;
  }

  .message {
    background-color: white;
    padding: 10px;
    border-radius: 10px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  }

  .right .message {
    background-color: #d3e3fc; /* Light blue for user messages */
  }

  .left .message {
    background-color: white; /* White for received messages */
  }

  .message-author {
    font-weight: bold;
    color: #333;
    text-decoration: none;
  }

  .message-date {
    font-size: 12px;
    color: gray;
    margin-left: 5px;
  }

  .message-content {
    display: block;
    margin-top: 4px;
    color: #333;
  }

  /* Chat Input */
  .chat-form {
    margin-top: 10px;
  }

  .chat-input {
    display: flex;
    align-items: center;
    background: white;
    border-radius: 25px;
    padding: 5px 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .chat-input textarea {
    flex: 1;
    border: none;
    outline: none;
    resize: none;
    padding: 10px;
    font-size: 14px;
    margin-top: 20px;
    border-radius: 25px;
  }

  .chat-input button {
    background-color: #28a745; /* Green send button */
    color: white;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 8px;
    cursor: pointer;
    transition: 0.3s;
  }

  .chat-input button:hover {
    background-color: #218838;
  }
`;

const ChatComponent = ({ data, onSubmit, id, getData, RefTab, setLoading }) => {
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const [form] = Form.useForm();
  const panelRef = useRef(null);

  const CommentAction = async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("POST", "consignment/getcommentTab", {
        UId: userInfo?.UID,
        RefTab: RefTab,
        RefId: id,
        Content: form.getFieldValue("CONTENT"),
      });
      form.resetFields();
      getData();
      // setLoading(false);
    } catch (error) {
      console.error("[getAssignedConsignments] error -->", error);
    }
  };

  useEffect(() => {
    if (panelRef.current) {
      panelRef.current.scrollTop = panelRef.current.scrollHeight;
    }
  }, [data]);

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      if (values.CONTENT.trim()) {
        onSubmit(values.CONTENT);
        form.resetFields();
      }
    });
  };

  return (


<>

    <ChatWrap>
      <div className="chat-container">
        <div className="chat-discussion" ref={panelRef}>
          {data?.length > 0 ? (
            data
              .sort((a, b) => new Date(a.CRON) - new Date(b.CRON))
              .map((comment) => (
                <div
                  key={comment.CRON}
                  className={`chat-message ${
                    comment.UID === userInfo?.UID ? "right" : "left"
                  }`}
                >
                  <div className="message">
                    <a className="message-author" href="#">
                      {comment.FULLNM}
                    </a>
                    <span className="message-date">
                      {new Date(comment.CRON).toLocaleString()}
                    </span>
                    <span className="message-content">{comment.CONTENT}</span>
                  </div>
                </div>
              ))
          ) : (
            <h6>No data found</h6>
          )}
        </div>

        <Form form={form} onFinish={CommentAction} className="chat-form">
          <div className="chat-input">
            <Form.Item
              className="w-100"
              name="CONTENT"
              rules={[{ required: true, message: "Enter your message" }]}
            >
              <Input.TextArea
                placeholder="Enter your message..."
                autoSize={{ minRows: 1, maxRows: 4 }}
              />
            </Form.Item>
            <Button type="primary" htmlType="submit" icon={<SendOutlined />} />
          </div>
        </Form>
      </div>
    </ChatWrap></>
  );
};

export default ChatComponent;
